import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './guards/auth.guard';
import { adminGuard, userOnlyGuard } from './guards/role.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login-page/login-page.component').then(m => m.LoginPageComponent),
    canActivate: [loginGuard], 
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./components/login-page/login-page.component').then(m => m.LoginPageComponent),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./components/home/home.component').then(m => m.HomeComponent),
    canActivate: [authGuard],
  },
  {
    path: 'assigned-files',
    loadComponent: () =>
      import('./components/assigned-files/assigned-files.component').then(m => m.AssignedFilesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'upload-file',
    loadComponent: () =>
      import('./components/upload-file/upload-file.component').then(m => m.UploadFileComponent),
    canActivate: [authGuard],
  },
  {
    path: 'view-files',
    loadComponent: () =>
      import('./components/view-files/view-files.component').then(m => m.ViewFilesComponent),
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'manage-files',
    loadComponent: () =>
      import('./components/manage-files/manage-files.component').then(m => m.ManageFilesComponent),
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'file-assignment',
    loadComponent: () =>
      import('./components/file-assignment/file-assignment.component').then(m => m.FileAssignmentComponent),
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'editor',
    loadComponent: () =>
      import('./components/editor/editor.component').then(m => m.EditorComponent),
    canActivate: [authGuard],
  },
  {
    path: 'glossary-upload',
    loadComponent: () =>
      import('./components/glossary-upload/glossary-upload.component').then(m => m.GlossaryUploadComponent),
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'view-glossary',
    loadComponent: () =>
      import('./components/view-glossary/view-glossary.component').then(m => m.ViewGlossaryComponent),
    canActivate: [authGuard],
  },
  {
    path: 'view-translation-memory',
    loadComponent: () =>
      import('./components/view-translation-memory/view-translation-memory.component').then(m => m.ViewTranslationMemoryComponent),
    canActivate: [authGuard],
  },
  {
    path: 'content-management',
    loadComponent: () =>
      import('./components/content-management/content-management.component').then(m => m.ContentManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'user-activity',
    loadComponent: () =>
      import('./components/user-activity/user-activity.component').then(m => m.UserActivityComponent),
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'llm-consumption',
    loadComponent: () =>
      import('./components/llm-consumption/llm-consumption.component').then(m => m.LlmConsumptionComponent),
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'manage-glossary',
    loadComponent: () =>
      import('./components/manage-glossary/manage-glossary.component').then(m => m.ManageGlossaryComponent),
    canActivate: [authGuard, adminGuard],
  },
  { path: '**', redirectTo: 'login' },
];